import CropStageMasterList from '../../slices/crop_management/crop_stage_master/CropStageMasterList'
import CropStageMasterDetails from '../../slices/crop_management/crop_stage_master/CropStageMasterDetails'
import CropScheduleVariantList from '../../slices/crop_management/crop_schedule_variant/CropScheduleVariantList'
import CropScheduleVariantDetails from '../../slices/crop_management/crop_schedule_variant/CropScheduleVariantDetails'
import DayWiseScheduleList from '../../slices/crop_management/day_wise_schedule/DayWiseScheduleList'
import DayWiseScheduleDetails from '../../slices/crop_management/day_wise_schedule/DayWiseScheduleDetails'

const cropManagementReducer = {
    cropStageMasterList: CropStageMasterList,
    cropStageMasterDetails: CropStageMasterDetails,
    cropScheduleVariantList: CropScheduleVariantList,
    cropScheduleVariantDetails: CropScheduleVariantDetails,
    dayWiseScheduleList: DayWiseScheduleList,
    dayWiseScheduleDetails: DayWiseScheduleDetails,
};

export default cropManagementReducer;
